import React from 'react'
import { useTranslate } from './TranslationText'
import { convertToCamelCase } from '../helper/convertToCamelCase';
import { getOrdinal } from '../helper/getOrdinal';
import { whiteCard } from '../common/cssclasses';

export default function PrizeCard({ data, specialRanks = false, isSpecialPrize = false , i=1}) {
    const { translate } = useTranslate();
    const lang = localStorage.getItem('eahsLang') ?? 'en';
    const fontSize = { fontSize: 12 };
    if (isSpecialPrize) {
        return (
            <div className={whiteCard} >
                <div className='row  rtl theadHorseSelect' style={{ fontSize: 14 }}>
                    <div className='col-6  bold'>
                        {translate('web.prizeName', 'Prize Name')}
                    </div>
                    <div className='col-6  bold'>
                        {translate('web.prizeVal', 'Prize Value')}
                    </div>
                </div>
                <div className='row mt-2 rtl ' style={fontSize}>
                    <div className='col-6 bold'>
                        {data?.prizeName} 
                    </div>
                    <div className='col-6 bold'>
                        {data?.prizeValue?.toLocaleString()} {translate('web.aed', 'AED')}
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className={whiteCard} >
            <div className='row  rtl theadHorseSelect' style={{ fontSize: 14 }}>
                {data.showPrizeCageoriesChampionsList.length > 0 &&
                    <div className='col-4  bold'>
                        {translate(`web.${convertToCamelCase(data?.stage)}`, data?.stage)}
                    </div>
                }
                {data?.fromRank == data?.toRank ?
                    <>
                        <div className='col-5  bold'>
                            {translate('web.rank', 'Rank')}
                        </div>
                    </> :
                    <>
                        <div className='col-3  bold'>
                            {translate('web.rankFrom', 'Rank From')}
                        </div>
                        <div className='col-2  bold'>
                            {translate('web.rankTo', 'Rank To')}
                        </div>
                    </>
                }
                <div className='col-3  bold'>
                    {translate('web.prizeVal', 'Prize Value')}
                </div>
            </div>
            <div className='row mt-2 rtl ' style={fontSize}>
                {data.showPrizeCageoriesChampionsList.length > 0 ?
                    <>
                        {data?.showPrizeCageoriesChampionsList.map((cat, index) => (
                            <>
                                <div className='col-4' >
                                    {cat.name}
                                </div>
                                {data?.fromRank == data?.toRank ?
                                    <div className='col-5 bold ' dangerouslySetInnerHTML={{ __html: getOrdinal(data?.fromRank, lang, data?.fromRank < 4 ? specialRanks : false) }} />
                                    :
                                    <>
                                        <div className='col-3 bold ' dangerouslySetInnerHTML={{ __html: getOrdinal(data?.fromRank, lang, data?.fromRank < 4 ? specialRanks : false) }} />

                                        <div className='col-2 bold ' dangerouslySetInnerHTML={{ __html: getOrdinal(data?.toRank, lang, data?.fromRank < 4 ? specialRanks : false) }} />
                                    </>
                                }
                                <div className='col-3 bold '>
                                    {data?.prizeValue.toLocaleString()} {translate('web.aed', 'AED')}
                                </div>
                            </>
                        ))}
                    </> :
                    <>
                        {data?.fromRank == data?.toRank ?
                            <div className='col-5 bold' dangerouslySetInnerHTML={{ __html: getOrdinal(data?.fromRank, lang, data?.fromRank < 4 ? specialRanks : false) }} />
                            :
                            <>
                                <div className='col-3 bold' dangerouslySetInnerHTML={{ __html: getOrdinal(data?.fromRank, lang, data?.fromRank < 4 ? specialRanks : false) }} />
                                <div className='col-2 bold' dangerouslySetInnerHTML={{ __html: getOrdinal(data?.toRank, lang, data?.fromRank < 4 ? specialRanks : false) }} />
                            </>
                        }
                        <div className='col-3 bold'>
                            {data?.prizeValue.toLocaleString()} {translate('web.aed', 'AED')}
                        </div>
                    </>
                }
            </div>
        </div>
    )
}
